export var EMFTypeCaps;
(function (EMFTypeCaps) {
    EMFTypeCaps["PURCHASE"] = "P";
    EMFTypeCaps["REDEEM"] = "R";
    EMFTypeCaps["SIP"] = "XSIP";
    EMFTypeCaps["SWP"] = "SWP";
})(EMFTypeCaps || (EMFTypeCaps = {}));
export var EMFType;
(function (EMFType) {
    EMFType["PURCHASE"] = "purchase";
    EMFType["REDEEM"] = "redeem";
    EMFType["SWP"] = "swp";
    EMFType["SWITCH"] = "switch";
    EMFType["STP"] = "stp";
})(EMFType || (EMFType = {}));
